// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx"}[chunkId] + "-" + {"230":"33d9ef9f9414ed803598","256":"61b18e0bc5a93cb61d21"}[chunkId] + ".js";
};